module.exports = __webpack_public_path__ + "img/button_mint.c9606599.png";